module.exports = __webpack_public_path__ + "img/metaMaskInstallationStep_7.e34df83.png";